<template>
  <div>
    <WizardStep v-if="hasEditMerchantSettingsPermission" :hideFooter="true">
      <template v-slot:content>
        <div class="col">
          <div class="col-xl-6" style="max-width:100%">
            <div class="form-group api-setting-container">
              <label>Api Key</label>
              <b-form-input
                type="text"
                class="form-control"
                v-model="keyText"
                readonly
              />
            </div>

            <br />
            <br />

            <br />
            <br />

            <div class="">
              <div class="form-group api-setting-container">
                <div></div>
                <div class="api-button-container">
                  <button
                    @click.prevent="generateKey"
                    class="btn btn-primary btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u"
                  >
                    Generate A New Key
                  </button>
                  <button
                    @click.prevent="showKey"
                    class="btn btn-primary btn-md kt-font-bold kt-font-transform-u show-btn"
                  >
                    Show Key
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </WizardStep>
    <LoadingModal v-bind="loadingModal" />
    <AlertModal
      v-bind="alertModal"
      v-model="alertModal.show"
      @dismiss="resetAlert"
    />
    <ConfirmationModal
      v-bind="confirmationModal"
      v-model="confirmationModal.show"
      @dismiss="resetConfirmation"
    />
  </div>
</template>

<script>
import WizardStep from "@/components/wizard/WizardStep";
import MerchantSettingsPermissionsMixin from "@/components/merchantsettings/MerchantSettingsPermissionsMixin.js";
import AlertModalMixin from "@/components/widgets/AlertModalMixin.js";
import { API, graphqlOperation } from "aws-amplify";

const AlertModal = AlertModalMixin.AlertModal;
const ConfirmationModal = AlertModalMixin.ConfirmationModal;

export default {
  mixins: [MerchantSettingsPermissionsMixin, AlertModalMixin],
  components: { WizardStep },
  props: ["heading"],
  data: () => {
    return {
      apiKey: "",
      keyText: ""
    };
  },
  methods: {
    async showKey() {
      if (!this.hasEditMerchantSettingsPermission) return;
      if (this.apiKey) return this.apiKey;
      let retrieveKeyResponseMessage = "";
      let alertType = AlertModal.INFORMATION;

      this.startLoadingDialog("Retrieving ApiKey");

      try {
        const backendKey = await this.retrieveKey();

        if (!backendKey) {
          retrieveKeyResponseMessage = "No Key Setup";
          alertType = AlertModal.INFORMATION;
          this.keyText = "No Key Setup";
        } else {
          retrieveKeyResponseMessage = "Api Key Retrieved";
          alertType = AlertModal.SUCCESS;
          this.keyText = this.apiKey = backendKey;
        }
      } catch (e) {
        this.$logger.error("Error getting api key");
        this.$logger.error(e);
        retrieveKeyResponseMessage =
          "An error occurred while retrieving the api key";
        alertType = AlertModal.ERROR;
      }
      this.stopLoadingDialog(retrieveKeyResponseMessage, alertType);
    },
    async generateKey() {
      if (!this.hasEditMerchantSettingsPermission) return;
      const confirmationTitle = "Generate Key?";
      const confirmationMessage = `Are you sure you want to generate a new api key? This will overwrite any existing keys`;
      const confirm = await this.confirm(
        confirmationTitle,
        confirmationMessage,
        ConfirmationModal.WARNING
      );
      if (!confirm) return;
      let generateKeyResponseMessage = "";
      let alertType = AlertModal.ERROR;
      this.startLoadingDialog("Generating the new Api Key");
      try {
        const newKey = await this.generateNewKey();

        if (!newKey) {
          generateKeyResponseMessage =
            "There was an error generating your api key";
          alertType = AlertModal.ERROR;
        } else {
          this.keyText = this.apiKey = newKey;
          generateKeyResponseMessage = "Your key has been generated";
          alertType = AlertModal.SUCCESS;
        }
      } catch (e) {
        this.$logger.error("Error generating api key");
        this.$logger.error(e);
        generateKeyResponseMessage =
          "An error occurred while generating the new api key";
        alertType = AlertModal.ERROR;
      }

      this.stopLoadingDialog(generateKeyResponseMessage, alertType);
    },
    async retrieveKey() {
      const getApiKey = `
              query GetApiKey {
                  getApiKey
              }
            `;
      const getApiKeyResponse = await API.graphql({
        ...graphqlOperation(getApiKey)
      });

      return getApiKeyResponse.data.getApiKey;
    },
    async generateNewKey() {
      const generateApiKey = `
              mutation GenerateApiKey {
                  generateApiKey
              }
            `;
      const generateApiKeyResponse = await API.graphql({
        ...graphqlOperation(generateApiKey)
      });

      return generateApiKeyResponse.data.generateApiKey;
    }
  }
};
</script>

<style lang="scss" scoped>
.api-setting-container > label {
  clear: both;
  float: left;
  font-weight: 500 !important;
  font-size: 14px !important;
}
.api-setting-container {
  display: grid !important;
  grid-template-columns: 2fr 2fr !important;
}
.api-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.api-button-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.show-btn {
  margin-left: 3%;
}

@media only screen and (max-width: 1024px) {
  .api-setting-container > label {
    clear: none;
    float: none;
    font-weight: 500 !important;
    font-size: 14px !important;
  }
  .api-setting-container {
    display: flex !important;
    flex-direction: column;
  }

  .api-button-container {
    display: flex;
    flex-direction: column;
  }

  .api-button-container > button {
    min-width: 100%;
  }
  .show-btn {
    margin-left: 0;
    margin-top: 3%;
  }
}
</style>
